import React from 'react';

import FormikFileUpload from 'components/formik/FormikFileUpload';
import { generateUploadFileList, getFileUploadMessages } from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import backofficeApiClient, {
  ResourceDownloadResponse,
} from 'api/backofficeApiClient';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';
import adminApiClient from 'api/adminApiClient';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  fieldName: string;
  files?: ResourceDownloadResponse[];
  isAdmin?: boolean;
  disabled: boolean;
};

export default React.memo((props: Props) => {
  const { fieldName, files, isAdmin, disabled } = props;

  const defaultFileList = files ? generateUploadFileList(files) : [];

  const uploadFileLinkFunction = isAdmin
    ? adminApiClient.getAssignmentTerminationAttachmentUploadLink.bind(
        backofficeApiClient,
      )
    : backofficeApiClient.getAssignmentTerminationAttachmentUploadLink.bind(
        backofficeApiClient,
      );

  return (
    <FormikFileUpload
      name={fieldName}
      isDraggable
      includeFileName
      maxFileCount={3}
      defaultFileList={defaultFileList}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      uploadLinkFunction={uploadFileLinkFunction}
      disabled={disabled}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
